module.exports = __webpack_public_path__ + "img/message-user.45e3a594.svg";